import { Divider, Table, TablePaginationConfig } from 'antd'
import React from 'react'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import usePage from 'src/hooks/usePage'
import { searchStationReport } from 'src/api/reports'
import StationReportSearch from './stationReportSearch'
import { SorterResult, TableCurrentDataSource } from 'antd/lib/table/interface'

const { Column } = Table

const StationReportPage: React.FC = () => {
  const { pageData, onQuery, appendSearchForm, submitSearchForm, fetchList } =
    usePage({
      getData: searchStationReport,
      searchData: searchStationReport,
      searchType: 'POST',
    })
  type SortItem = { field: string; order: 'asc' | 'desc' }

  const handleTableChange = (
    pagination: TablePaginationConfig,
    _filters: Record<string, (string | number | boolean)[] | null>,
    sorter: SorterResult<any> | SorterResult<any>[],
    extra: TableCurrentDataSource<any>
  ) => {
    const current = pagination.current ?? 1
    const pageSize =
      pagination.pageSize ?? (parseInt(pageData.query.pageSize) || 10)

    const sorterArr = Array.isArray(sorter) ? sorter : [sorter]
    const sorts: SortItem[] = sorterArr
      .filter((s) => s && s.field && s.order)
      .map((s) => ({
        field: String(s.field),
        order: s.order === 'ascend' ? 'asc' : 'desc',
      }))

    if (extra.action === 'paginate') {
      appendSearchForm({ buttonAction: '' })
      onQuery({
        page: String(current - 1),
        pageSize: String(pageSize),
      })
      return
    }

    if (extra.action === 'sort') {
      onQuery({
        page: String(current - 1),
        pageSize: String(pageSize),
        sorts: JSON.stringify(sorts),
      })
      return
    }

    if (extra.action === 'filter') {
      onQuery({
        page: String(current - 1),
        pageSize: String(pageSize),
        sorts: JSON.stringify(sorts),
      })
    }
  }

  return (
    <>
      <Divider />
      <DndProvider backend={HTML5Backend}>
        <Table
          className="table-sorting"
          rowKey="eventId"
          dataSource={pageData.data}
          loading={pageData.loading}
          onChange={handleTableChange}
          pagination={{
            current: parseInt(pageData.query.page) + 1,
            total: pageData.total,
            pageSize: parseInt(pageData.query.pageSize) || 10,
            showSizeChanger: true,
            pageSizeOptions: ['10', '25', '50', '100'],
          }}
          title={() => (
            <StationReportSearch
              appendSearchForm={appendSearchForm}
              submitSearchForm={submitSearchForm}
            />
          )}
        >
          <Column
            width={120}
            dataIndex="stationId"
            title="Station Id"
            sorter={{ multiple: 1 }}
          />
          <Column
            dataIndex="stationName"
            title="Name"
            sorter={{ multiple: 1 }}
          />

          <Column dataIndex="userName" title="User" />
          <Column dataIndex="age" title="Age" sorter={{ multiple: 1 }} />
          <Column
            dataIndex="gender"
            sorter={{ multiple: 1 }}
            title="Gender"
            filters={[
              {
                text: 'Male',
                value: 'MALE',
              },
              {
                text: 'Female',
                value: 'FEMALE',
              },
            ]}
            filterMode="tree"
            onFilter={(value: string, record: any) => record.gender === value}
          />
          <Column
            dataIndex="deviceType"
            title="Device Type"
            sorter={{ multiple: 1 }}
          />
          <Column
            dataIndex="providerCountry"
            title="Country"
            sorter={{ multiple: 1 }}
          />
          <Column
            dataIndex="eventDuration"
            title="Event Duration"
            sorter={{ multiple: 1 }}
            render={(text) => <span>{text} sec</span>}
          />
          <Column
            dataIndex="eventDate"
            title="Event Date"
            sorter={{ multiple: 5 }}
          />
          <Column
            dataIndex="clientName"
            title="Client Name"
            sorter={{ multiple: 1 }}
          />
        </Table>
      </DndProvider>
    </>
  )
}

StationReportPage.displayName = 'StationReportPage'
export default StationReportPage
